import { flow, getOr } from 'lodash/fp';

import selectRawPrices from '../select-raw-price';

const getOrNull = getOr(null);
const selectPrices = flow(selectRawPrices, getOrNull('data'));

export default selectPrices;
